import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { TopRowBox } from './TopRowBox';

export const TopRowFillPrice = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const metrics = tradePlanStore.getTradePlanPositionMetrics(tradePlanId);
  if (!metrics)
    return (
      <TopRowBox
        backgroundColor={colors.grey}
        color={colors.lightGrey}
        width="100px"
      >
        Fill:
      </TopRowBox>
    );
  const fillPrice = metrics.fillPrice;
  return (
    <TopRowBox
      backgroundColor={colors.grey}
      color={colors.lightGrey}
      width="100px"
    >
      {`Fill: ${fillPrice == null ? '--' : ApplyRounding(fillPrice, 2)}`}
    </TopRowBox>
  );
});
